import _, { get, isEmpty } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomSelectDropDown from "../../../../app/common-components/CustomSelectDropDown";
import { hideOffCanvas } from "../../../../app/commonSlice";
import { effciencyApi } from "../../../../app/services/efficiencyApi";
// import { validateProject } from "../../DevopsInsights/Efficiency/helpers";
import PropTypes from "prop-types";
import { ProjectContext } from "./Projects";
// import DataTable from "../../../app/common-components/DataTable";
// import { Card } from "react-bootstrap";
import Spinners from "../../../../app/common-components/Spinner";
import { getGitlabProjectList, getProjectList, getSonarProjectListAPI } from "./CMDBSlice";

const ProjectCustomDrillDown = ({
  title,
  rowId,
  projectType,
  projectName,
  tablerecall,
}) => {
  const context = useContext(ProjectContext);
  const offcanvasState = useSelector((state) => state.common?.offcanvasState);
  const { projectListData, GitlabprojectListData ,getSonarProjectListData } = useSelector((state) => state.cmdbId);
  const [saveLoader, setSaveLoader] = useState(false);
  const { userName } = useSelector((state) => state.common.loggedUser);
  const { state: locationState } = useLocation();
  const payloadid = locationState?.id;
  if (!payloadid) {
    // window.location.replace("/efficiency/appConfig");
  }
  const dispatch = useDispatch();
  const dropDownData = get(offcanvasState, "selectedData", {});

  const [state, setstate] = useState({
    toolOptions: [],
    typeOptions: [],
    projectNameOptions: [],
    name: "",
    typeName: "Nothing to select",
    toolName: "Nothing to select",
    projectName: "",
    projectKey: "",
    projectLead: "",
    error: false,
    errorMessage: "",
    rowId: rowId,
    initialLoad: true,
    fieldChange: false,
    cspTableData: [],
    cspDrillDownTableData: [],
  });
  const [addManageProject] = effciencyApi.useAddManageProjectMutation();
  const [getProjectType] = effciencyApi.useLazyGetProjectTypeQuery({});
  const [getProjectTool] = effciencyApi.useLazyGetProjectToolQuery({});
  useEffect(() => {
    dispatch(getProjectList());
    dispatch(getGitlabProjectList());
    dispatch(getSonarProjectListAPI());

  }, []);

  useEffect(() => {
    if(title === "Update Project"){
      setstate((state) => ({
        ...state,
        projectName : projectName,
      }));
    }
  },[projectName]);

  useEffect(() => {
    let projectName = [];
      if (state.toolName === "Jira") {
        projectName = !_.isEmpty(projectListData) ? projectListData.map((data) => ({
        label : data.projectName,
        value : data.projectName,
        projectKey : data.projectKey,
        projectLead : data.projectLeadFullName
      }))
      : [];
      } 
      if (state.toolName === "GitLab") {
        projectName = !_.isEmpty(GitlabprojectListData) ? GitlabprojectListData.map((data) => ({
        label : data.projectName,
        value : data.projectName,
        projectKey : data.projectKey,
        projectLead : data.projectLeadFullName
      }))
      : [];
      }
      if (state.toolName === "SonarQube") {
        projectName = !_.isEmpty(getSonarProjectListData) ? getSonarProjectListData.map((data) => ({
        label : data,
        value : data,
      }))
      : [];
      }
      console.log(projectName);
      setstate((state) => ({
        ...state,
        projectNameOptions : projectName,
        // projectName: "",
      }));
  }, [state.typeName, state.toolName, projectListData, GitlabprojectListData ,getSonarProjectListData]);

  const onChangeProjectName = (key, lead) => {
    setstate((state) => ({
      ...state,
      projectKey : key,
      projectLead : lead
    }));
  };

  const getDropDowndata = async (projectType) => {
    if (state.initialLoad) {
      getProjectType(new Date().getTime())
        .unwrap()
        .then(async (typeList) => {
          // Map typeList to dropdown format
          const typeOptions = !isEmpty(typeList)
            ? typeList.map((item) => ({ label: item, value: item }))
            : [];
          // Default type: first from API or fallback
          const defaultType = projectType && projectType !== "" ? projectType : (typeOptions[0]?.value || "");

          let { data: toolsList } = await getProjectTool({
            type: defaultType,
            cacheTimeStamp: new Date().getTime(),
          });
          const toolOptions = !isEmpty(toolsList)
            ? toolsList.map((tool) => ({ label: tool, value: tool }))
            : [];
          // Default tool: first from API or fallback
          const defaultTool = toolOptions[0]?.label || "";

          if (title !== "Update Project") {
            setstate((state) => ({
              ...state,
              toolOptions: toolOptions,
              typeOptions: typeOptions,
              toolName: defaultTool,
              typeName: defaultType,
              initialLoad: false,
            }));
          } else {
            setstate((state) => ({
              ...state,
              name: get(dropDownData, "selected.projectName", ""),
              toolOptions: toolOptions,
              typeOptions: typeOptions,
              toolName: get(dropDownData, "selected.selectedTool", defaultTool),
              typeName: get(dropDownData, "selected.selectedType", defaultType),
              projectName: get(dropDownData, "selected.projectName", ""),
              initialLoad: false,
              closeDrillDown,
            }));
          }
        });
      return "";
    }
    if (state.fieldChange) {
      let { data: tools } = await getProjectTool({
        type: state.typeName,
        cacheTimeStamp: new Date().getTime(),
      });
      tools =
        !isEmpty(tools) &&
        tools.map((tool) => ({
          label: tool,
          value: tool,
        }));

      setstate((state) => ({
        ...state,
        toolOptions: tools,
        toolName: get(tools, "[0].label", ""),
      }));
    }
  };
  useEffect(() => {
    getDropDowndata(projectType);
  }, [projectType,state.typeName]);
  const handleOnChange = (name, value) => {
    (name === "typeName" || name === "toolName") && setstate((state) => ({ ...state, projectName: " " }));

    name === "projectName" &&
      state.error &&
      setstate((state) => ({ ...state, error: false }));
    setstate((state) => ({
      ...state,
      [name]: value,
      fieldChange: true,
    }));
  };

  const manageProject = () => {
    let validation = true;
     if (state.projectName === "") {
      setstate((state) => ({
        ...state,
        error: true,
        errorMessage: "Project name should not be empty",
      }));
      validation = false;
    }
  
    if (validation) {
      const payload = {
        createdDt: new Date(),
        id: get(dropDownData, "selected.id", "") + "",
        name: state.projectName,
        tool: state.toolName,
        type: state.typeName,
      };
      addManageProject({ payload, id: state.rowId, userName }).unwrap(setSaveLoader(true))
        .then((data) => {
          if (data?.statusCodeValue === 400) {
            context.setProjectState((state) => ({
              ...state,
              alert: true,
              alertType: "error",
              alertMessage: data.body,
            }));
            setSaveLoader(false);
            return "";
          } else if([200, 201, 204].includes(data?.statusCodeValue)){
            closeDrillDown();
            context.setProjectState((state) => ({
              ...state,
              alert: true,
              alertType: "success",
              alertMessage: data.body,
              loadPage: !state.loadPage,
            }));
            setSaveLoader(false);
            tablerecall();
          }
        })
         .catch((error) => {
          console.log("err", error);
        });
    }
  };
  
  const closeDrillDown = () => {
    dispatch(hideOffCanvas(false));
  };

  return (
    <>
      {saveLoader ? (
        <Spinners />
      ) : (
        <>
          <div className="row m-0">
            <CustomSelectDropDown
              labelName={"Type*"}
              name={"Type"}
              options={state.typeOptions}
              value={state.typeName}
              onChange={(choice) => {
                handleOnChange("typeName", choice.value);
              }}
            />
            <CustomSelectDropDown
              labelName={"Tool Name*"}
              name={"Tool Name"}
              options={state.toolOptions}
              value={state.toolName}
              onChange={(choice) => {
                handleOnChange("toolName", choice.value);
              }}
            />
            <CustomSelectDropDown
              labelName={"Project Name*"}
              name={"Project Name"}
              options={state.projectNameOptions}
              value={state.projectName}
              onChange={(choice) => {
                handleOnChange("projectName", choice.value);
                onChangeProjectName(choice.projectKey, choice.projectLead);
              }}
              error={state.error}
              errorMessage={state.errorMessage}
              
            />
          </div>
  
          {/* Corrected the button container position */}
          <div className="projectSave btnwrap save-btn">
            <button
              className="cancelBtnStyle btn btn-primary"
              data-testid="cancelBtn"
              onClick={() => closeDrillDown()}
            >
              Cancel
            </button>
            <button className="btnStyle btn btn-primary" 
            data-testid="saveBtn"
            onClick={manageProject}>
              Save
            </button>
          </div>
        </>
      )}
    </>
  );  
  };
ProjectCustomDrillDown.propTypes = {
  title: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowId: PropTypes.arrayOf(PropTypes.object).isRequired,
  accountId: PropTypes.arrayOf(PropTypes.object).isRequired,
  projectType: PropTypes.arrayOf(PropTypes.object).isRequired,
  projectName: PropTypes.string.isRequired,
  tablerecall: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default ProjectCustomDrillDown;

